import store from "@/store";
const onlyAuth = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    next("/login");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Shop"
    },
    path: "/shop",
    name: "Shop",
    component: () => import("@/views/shop/ShopList.vue")
  },
  {
    meta: {
      title: "ShopDetail"
    },
    path: "/shopDetail",
    name: "ShopDetail",
    component: () => import("@/views/shop/ShopDetail.vue")
  },
  {
    meta: {
      title: "ShopOrder"
    },
    path: "/shopOrder",
    name: "ShopOrder",
    component: () => import("@/views/shop/ShopOrder.vue")
  },
  {
    meta: {
      title: "ShopComplete"
    },
    path: "/shopComplete",
    name: "ShopComplete",
    component: () => import("@/views/shop/ShopComplete.vue")
  },
  {
    meta: {
      title: "ShopSuccess"
    },
    path: "/shopSuccess",
    name: "ShopSuccess",
    component: () => import("@/views/shop/ShopSuccess.vue")
  },
  {
    meta: {
      title: "ShopFail"
    },
    path: "/shopFail",
    name: "ShopFail",
    component: () => import("@/views/shop/ShopFail.vue")
  }
];
